import CustomFormInput from "@components/CustomFormInput/CustomFormInput";
import { Button } from "@components/ui/button";

const Step3 = () => {
  return (
    <div className="flex flex-col gap-5 rounded-md">
      <div className="flex flex-col p-4 gap-1 h-max bg-white rounded-md">
        <span className="text-xss font-semibold tracking-widest border rounded-full w-max px-2 bg-green-50 text-green-600">
          EMAIL VERIFIED
        </span>
        <span className="font-semibold text-sm">
          Complete your basic profile
        </span>
        <span className="text-xss font-medium text-light-black">
          Add the essentials first. This creates you basic candidate profile
        </span>
      </div>
      <div className="flex flex-col bg-white rounded-md p-4">
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <span className="font-semibold text-sm">Career details</span>
            <span className="font-medium text-xss text-light-black">
              Add your basic career details.
            </span>
          </div>
          <span className="rounded-full font-semibold text-xss text-blue-600 bg-blue-50 px-2 py-0.5">
            Step 3
          </span>
        </div>
        {/* Form container */}
        <div className="flex flex-col w-full mt-5 gap-3">
          <CustomFormInput
            label="Industry"
            // type="dropdown"
            // dropdownList={['Technology/Software']}
          />
           <CustomFormInput
            label="Current job title"
            placeholder="Enter you job title"
          />
           <CustomFormInput
            label="Location"
            placeholder="Enter your location"
          />
        </div>
        <div className="flex items-center gap-2 w-full mt-4">
          <button className="rounded-md bg-white border text-primary h-9 px-3 font-semibold text-xs hover:bg-light-white-400">
            Back
          </button>
          <Button variant="secondary" className="flex-1">
           Generate my basic profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Step3;
